import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IInformacionProyectos } from "../../../interfaces/InformacionProyectos";
import { IRepresentacion } from "../../../interfaces/Representacion";
import { getListaRepresentaciones } from "../../../api/representation";
import { getInfoProyectos, getInfoProyectosRegionales, getInfoProyectosRegionalesFiltrada } from "../../../api/informacionProyectos";
import Select from 'react-select'
import ProjectListItem from "../../../components/Generic/ProjectListItem";
import { ChartContainerLoader } from "../../../components/Generic/Charts";
import Filtros from "../../IniciativasWS/Components/Filtros";

const Iniciativas: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'iniciativas' })

  const [iniciativas, setIniciativas] = useState<IInformacionProyectos[]>()

  useEffect(() => {
    getInfoProyectosRegionales()
      .then((res) => {
        setIniciativas(res)
      })
    return () => {
      setIniciativas(undefined)
    }
  }, [])

  const filter = (contraparte?: number, palabraClave?: number, busquedaTextual?: string, isArchivo?: number) => {
    getInfoProyectosRegionalesFiltrada({ clave: palabraClave, text: busquedaTextual })
    .then((res) => {
        setIniciativas(res)
    })
  }

  if (!iniciativas) {
    return <ChartContainerLoader colSize="12" />;
  }

  return (
    <div className="card" id="iniciativas">
      <div className="card-body">
        <h5 className="card-title">{t("title")}</h5>
        <div className="row mb-1">
          <div className="col">
            <small>
              {t("resultados_ini")} <strong>{iniciativas.length}</strong> {t("resultados_fin")}
            </small>
          </div>
        </div>
        <div className="row">
          <Filtros colClass="col-md-12" filter={filter} pageType="regionales" paisId={"IR"}/>
        </div>
        <div className="row">
          <div className="col-md-12">
            <ul className="list-unstyled">
              {iniciativas.map((proyecto, index) => (
                <ProjectListItem key={index} proyecto={proyecto} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Iniciativas